import { SendAnalytics, GenerateLabel } from "../main";

const label = 'qna'
const analytics = SendAnalytics('Q&A')

/** 👇 Users view qna page */
const ViewQnaMenu = () => analytics({
  label: GenerateLabel({ label }),
  action: 'qna - view main page',
  name: 'view_qna_menu',
});

/** 👇 Users click history */
const ClickHistory = () => analytics({
  label: GenerateLabel({ label }),
  action: 'qna - click history',
  name: 'click_history',
});

/** 👇 Users click TS */
const ClickTanyaSaham = () => analytics({
  label: GenerateLabel({ label }),
  action: 'qna - click tanya saham',
  name: 'click_tanya_saham',
});

/** 👇 Users click tanya porto */
const ClickTanyaPorto = () => analytics({
  label: GenerateLabel({ label }),
  action: 'qna - click tanya porto',
  name: 'click_tanya_porto',
});

/** 👇 Users click pertanyaan lain */
const ClickTanyaLainnya = () => analytics({
  label: GenerateLabel({ label }),
  action: 'qna - click tanya lainnya',
  name: 'click_tanya_lainnya',
});

/** 👇 Users click faq category */
const ClickFaq = ({ category = '' }) => analytics({
  label: GenerateLabel({ label, category }),
  action: 'qna - click faq category',
  name: 'click_faq',
});

/** 👇 Users click faq detail */
const ClickFaqDetail = ({ category = '', question = '' }) => analytics({
  label: GenerateLabel({ label, category, question }),
  action: 'qna - click faq detail',
  name: 'click_faq_detail',
});

const Qna = {
  ViewQnaMenu,
  ClickHistory,
  ClickTanyaSaham,
  ClickTanyaPorto,
  ClickTanyaLainnya,
  ClickFaq,
  ClickFaqDetail,
};

export default Qna;
